import React from "react";
import { Link } from "react-router-dom";

// Mobile-only floating signup dock — pinned to the bottom of the viewport on
// phones/tablets and hidden on desktop. The App-level gate hides this on
// /admin/* and on dedicated form pages so it never overlaps a submit button.
//
// No icons here — smaller phones (≈360 px wide) were wrapping "Publisher
// Sign Up" onto two lines. Text-only labels keep both CTAs on a single line
// across every real-world phone size.
//
// Uses env-safe iOS bottom-inset padding so the dock never sits under the
// iPhone home-indicator bar.
const MobileSignupDock = () => (
  <div
    className="lg:hidden fixed inset-x-0 bottom-0 z-40 pointer-events-none"
    style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    data-testid="mobile-signup-dock"
  >
    <div className="pointer-events-auto mx-3 mb-3 rounded-2xl border border-slate-700/60 bg-slate-950/85 backdrop-blur-xl shadow-[0_-6px_30px_rgba(0,0,0,0.55)]">
      <div className="flex items-stretch gap-2 p-2">
        <Link
          to="/apply"
          data-testid="mobile-dock-publisher-btn"
          className="flex-1 min-w-0 flex items-center justify-center rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold text-[12px] leading-none px-2 py-3.5 shadow-lg shadow-blue-500/30 active:scale-[0.98] transition-transform whitespace-nowrap tracking-tight"
        >
          Publisher Sign Up
        </Link>
        <Link
          to="/buyer"
          data-testid="mobile-dock-buyer-btn"
          className="flex-1 min-w-0 flex items-center justify-center rounded-xl border-2 border-slate-600 text-white font-semibold text-[12px] leading-none px-2 py-3.5 hover:border-blue-400 hover:bg-white/5 active:scale-[0.98] transition-all whitespace-nowrap tracking-tight"
        >
          Buyer Sign Up
        </Link>
      </div>
    </div>
  </div>
);

export default MobileSignupDock;
